module.exports = __webpack_public_path__ + "components/rewards/skiset/static/logo-b4dae46f3b4c12b2fe2abc15ccd6a9e4.jpg";